module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/telegram-c098afe3a464bed8ad5337d4cee490b7.png";